import BigNumber from 'bignumber.js'
import React, { useMemo } from 'react'
import { Text } from '@mantine/core'
import { ErrorBeacon, TextLoader } from '@/components'
import { getDexInfoFromDenom } from '@/config'
import { useMarketPriceQuery } from '../queries'
import { useSelectedDenom } from '../../../contexts/denom'

const StakeStatMarketRate: React.FC = () => {
  const [denom] = useSelectedDenom()

  const dexInfo = useMemo(() => getDexInfoFromDenom(denom), [denom])

  const { data: marketPrice, isLoading: isMarketPriceLoading, error: marketPriceError } = useMarketPriceQuery()

  const dexPriceValue = useMemo(() => {
    if (!marketPrice?.dexAvailability) return '0'
    return new BigNumber(marketPrice.dexStTokenValue).decimalPlaces(3).toString()
  }, [marketPrice])

  if (dexInfo == null) {
    return <Text sx={(t) => ({ color: t.colors.gray[7] })}>None</Text>
  }

  if (marketPriceError || (!isMarketPriceLoading && dexPriceValue === '0')) {
    return <ErrorBeacon label={`Unable to load ${dexInfo.name} market price at this time.`} />
  }

  return (
    <TextLoader loading={isMarketPriceLoading} sx={(t) => ({ color: t.colors.gray[7] })}>
      1 st{denom} = {dexPriceValue} {denom}
    </TextLoader>
  )
}

export { StakeStatMarketRate }
